import React, { useState } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import laptop from "../../laptop.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import toast from "react-hot-toast";

export default function About({ projectRef }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText("chaubeypushkar4@gmail.com");
    setCopied(true);
    toast.success("Email copied");
    setTimeout(() => setCopied(false), 2000);
  };
  const scroll = () =>
    projectRef?.current?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="relative overflow-hidden bg-custombg py-24 px-6">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 h-[450px] w-[450px] rounded-full bg-purple-500/20 blur-[120px]" />
        <div className="absolute -bottom-24 -right-24 h-[500px] w-[500px] rounded-full bg-blue-500/20 blur-[140px]" />
        <div className="absolute top-1/3 left-1/2 h-[320px] w-[320px] -translate-x-1/2 rounded-full bg-pink-500/20 blur-[120px]" />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.04)_1px,transparent_1px)] bg-[size:40px_40px]" />
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />
      <div className="relative mx-auto max-w-7xl grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          className="space-y-8"
        >
          <p className="uppercase tracking-[0.35em] text-yellow-400 font-semibold">
            Software Engineer
          </p>
          <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight">
            Hi, I'm <span className="text-yellow-400">Pushkar</span>
            <br />
            Building Modern Digital Products.
          </h1>
          <p className="text-lg text-gray-400 max-w-xl">
            Software Engineer with 2+ years of experience building
            production-ready React, Next.js and React Native applications.
          </p>
          <div className="flex flex-wrap gap-6 text-white">
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faWhatsapp} className="text-green-400" />
              <span>+91 7023781208</span>
            </div>
            <a
              href="https://www.linkedin.com/in/pushkar-chaubey-145311202/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 hover:text-blue-400"
            >
              <FontAwesomeIcon icon={faLinkedin} />
              <span>LinkedIn</span>
            </a>
          </div>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={scroll}
              className="rounded-xl bg-yellow-400 px-6 py-3 font-semibold text-black hover:scale-105 transition"
            >
              View Projects
            </button>
            <button
              onClick={copy}
              className="rounded-xl border border-white/15 bg-white/5 px-6 py-3 text-white flex items-center gap-2 hover:bg-white/10"
            >
              chaubeypushkar4@gmail.com{" "}
              {copied ? (
                <CheckCircleIcon className="text-green-400" />
              ) : (
                <ContentCopyIcon />
              )}
            </button>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-8"
        >
          <Lottie animationData={laptop} className="w-full h-[420px]" />
        </motion.div>
      </div>
    </section>
  );
}
